var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-container',[_c('h1',{staticClass:"text-h5 text-center mt-5"},[_vm._v("About")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }